var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.162 20.894h-2.5c-.024-2.047 0-4.08-.017-6.148h-2.032c-.09-.262-.114-1.96-.041-2.42h2.055c.01-.153.022-.267.022-.382 0-.526-.018-1.052.008-1.577.012-.339.065-.675.158-1.001.326-1.073 1.07-1.704 2.16-1.928.607-.126 1.221-.084 1.835-.05.274.015.539.043.822.068v2.127c-.173.009-.333.018-.492.024-.382.013-.767 0-1.148.043-.496.054-.773.309-.806.8-.038.6-.01 1.2-.01 1.837.793.056 1.575-.011 2.39.038l-.312 2.4h-2.092v6.169z",
    fill: "#fff"
  })));
}
export default SvgFacebook;